/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.circle-plus-filled\":\"Plus sign inside a circle\"}");